import React from "react";
import AppDivider from "../../../../components/AppDivider";
import AppText from "../../../../components/AppText";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const spacingOptions = [
  { key: "none", label: "None", value: "0 px" },
  { key: "sm", label: "SM", value: "8 px" },
  { key: "md", label: "MD", value: "16 px" },
  { key: "lg", label: "LG", value: "24 px" },
];

const niceToKnowItems = [
  "MD mit 16 px Abstand oberhalb und unterhalb ist der Standard.",
  "Divider trennen inhaltliche Bereiche innerhalb derselben Oberfläche.",
  "Keine Divider verwenden, wenn Card-Zonen oder normaler Stack-Abstand die Hierarchie bereits ausreichend zeigen.",
];

export default function DividersDocs() {
  return (
    <DocsSectionCard title="Dividers">
      <div className="ds-docs-spotlight-grid">
        <DocsPreviewPanel>
          <div className="ds-docs-preview-surface ds-docs-divider-preview">
            {spacingOptions.map((option) => (
              <div key={option.key} className="ds-docs-divider-preview__row">
                <div className="ds-docs-divider-preview__meta">
                  <AppText variant="label-2">{option.label}</AppText>
                  <AppText variant="body-3" tone="tertiary">{option.value} je Seite</AppText>
                </div>
                <div className="ds-docs-divider-preview__sample">
                  <AppText variant="body-1">Bereich A</AppText>
                  <AppDivider spacing={option.key} />
                  <AppText variant="body-1">Bereich B</AppText>
                </div>
              </div>
            ))}
          </div>
        </DocsPreviewPanel>

        <DocsNiceToKnow items={niceToKnowItems} />
      </div>
    </DocsSectionCard>
  );
}
